import script from "./RaceFormat.vue?vue&type=script&setup=true&lang=js"
export * from "./RaceFormat.vue?vue&type=script&setup=true&lang=js"

import "./RaceFormat.vue?vue&type=style&index=0&id=7554aa0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7554aa0c"]])

export default __exports__